<div class="order-summary-container sidebar" *ngIf="!getIsMobile() && (shoppingCart$|async) as  shoppingCart">

    <div class="order-summary-header" fxLayout="column" fxLayout.lt-md="row" fxLayoutAlign="space-between">

        <!--      Timer-->
        <btx-countdown-timer></btx-countdown-timer>
        <div>
            <h2 translate="shared.labels.amountPayable"></h2>

            <btx-product-price class="checkout-total-price" [value]="shoppingCart.totalPrice" classList="total-price">
            </btx-product-price>
        </div>

    </div>

    <div class="order-summary-content" fxLayout="column" fxFlex="100" fxLayoutGap="10px">

        <!--  Action Button    -->
        <button class="action-button" mat-raised-button color="primary" (click)="onClicked()">
            {{buttonLabel}}
        </button>

        <ng-container *ngIf="!isBuyFast && isShowButton && !showBackToEventPackageDetailBtn">
            <a mat-stroked-button color="secondary" class="heightButton" translate="shared.labels.continueShopping"
                [href]="routerService.getSeamHomePageUrl()">
            </a>
        </ng-container>

        <button class="action-button" mat-stroked-button color="primary" translate="shared.labels.eventPackageReturn"
            *ngIf="showBackToEventPackageDetailBtn"
            (click)="navigateToEventPackageDetailPage(shoppingCart.btxEventPackageId)">

        </button>

        <!--        Upsell Price-->
        <div *ngIf="upsellTotalPrice$|async as upsellTotalPrice" fxLayout="row" fxLayoutAlign="space-between start">
            <span translate="shared.labels.boughtTogether"> </span>
            <btx-product-price [value]="upsellTotalPrice"></btx-product-price>
        </div>

        <!--        Delivery Choice-->
        <div *ngIf="getDeliveryChoice(shoppingCart) as deliveryChoice" fxLayout="row"
            fxLayoutAlign="space-between start">
            <span style="display: none">{{deliveryChoice.deliveryName}} </span>
            <span translate="shared.labels.orderValue"> </span>
            <btx-product-price [value]="deliveryChoice.amount"></btx-product-price>
        </div>

        <!--        Admin Fee Charge-->
        <div *ngIf="shoppingCart.adminFeeCharge as adminFeeCharge" fxLayout="row" fxLayoutAlign="space-between start">
            <span>{{adminFeeCharge.chargeName}} </span>
            <btx-product-price [value]="adminFeeCharge.amount"></btx-product-price>
        </div>

        <!--         Total Ticket-->
        <div class="total-ticket" fxLayout="row" fxLayoutAlign="space-between start">

            <span class="label" translate="shared.labels.totalTickets"
                [translateParams]="{count:shoppingCart.totalTicket}"></span>

            <!--            -->
            <btx-product-price class="checkout-ticket-price" [value]="shoppingItemsTotalPrice$|async">

            </btx-product-price>



        </div>
        <!-- Ticket Protection Premium-->
        <div *ngIf="shoppingCart.totalTicketProtectionPremium as totalTicketProtectionPremium" fxLayout="row"
            fxLayoutAlign="space-between start">
            <span translate="shared.labels.protectionValue"> </span>
            <btx-product-price [value]="shoppingCart.totalTicketProtectionPremium"></btx-product-price>
        </div>
        <div>

        </div>
    </div>
</div>
<div class="order-summary-container sidebar" *ngIf="getIsMobile() && (shoppingCart$|async) as  shoppingCart">



    <div class="collapse-panel" fxLayout="column" fxLayoutGap="5px" fxHide.lt-md="false" #collapsePanel>

        <div class="collapse-bar">
            <div class="bar"></div>
        </div>

        <!--        Upsell Price-->
        <div *ngIf="upsellTotalPrice$|async as upsellTotalPrice" fxLayout="row" fxLayoutAlign="space-between start">
            <span translate="shared.labels.boughtTogether"> </span>
            <btx-product-price [value]="upsellTotalPrice"></btx-product-price>
        </div>

        <!--        Delivery Choice-->
        <div *ngIf="getDeliveryChoice(shoppingCart) as deliveryChoice" fxLayout="row"
            fxLayoutAlign="space-between start">
            <span style="display: none">{{deliveryChoice.deliveryName}} </span>
            <span translate="shared.labels.orderValue"> </span>
            <btx-product-price [value]="deliveryChoice.amount"></btx-product-price>
        </div>

        <!--        Admin Fee Charge-->
        <div *ngIf="shoppingCart.adminFeeCharge as adminFeeCharge" fxLayout="row" fxLayoutAlign="space-between start">
            <span>{{adminFeeCharge.chargeName}} </span>
            <btx-product-price [value]="adminFeeCharge.amount"></btx-product-price>
        </div>

        <!--         Total Ticket-->
        <div class="total-ticket" fxLayout="row" fxLayoutAlign="space-between start">

            <span class="label" translate="shared.labels.totalTickets"
                [translateParams]="{count:shoppingCart.totalTicket}"></span>

            <!--            -->
            <btx-product-price class="checkout-ticket-price" [value]="shoppingItemsTotalPrice$|async">

            </btx-product-price>



        </div>

        <!-- Ticket Protection Premium-->
        <div *ngIf="shoppingCart.totalTicketProtectionPremium as totalTicketProtectionPremium" fxLayout="row"
            fxLayoutAlign="space-between start">
            <span translate="shared.labels.protectionValue"> </span>
            <btx-product-price [value]="shoppingCart.totalTicketProtectionPremium"></btx-product-price>
        </div>

    </div>

    <div class="order-summary-header" fxLayout="column" fxLayout.lt-md="row" fxLayoutAlign="space-between">

        <!--      Timer-->

        <div class="mobile-expand-trigger" [expandToggle]="collapsePanel" fxLayout="row">
            <span class="material-icons-outlined expand-icon" fxHide fxShow.lt-md="true">
                expand_less
            </span>
            <div>
                <h2 translate="shared.labels.amountPayable"></h2>

                <btx-product-price class="checkout-total-price" [value]="shoppingCart.totalPrice"
                    classList="total-price">
                </btx-product-price>
            </div>

        </div>
        <btx-countdown-timer></btx-countdown-timer>

    </div>

    <!-- WTSTR-200: mobilde akış sağdan ilerler — ana aksiyon ("Sepeti Onayla" / teslimatta "Devam")
         sağda ve mavi, ikincil buton solda. Yer değişimi yalnızca CSS order ile (scss: .confirm-cart);
         DOM sırası BİLEREK aynı: mobil app hideElementsScript "Sepeti Onayla"yı
         ".order-summary-content > button" (ilk button) ile buluyor. -->
    <div class="order-summary-content" fxLayout="row" fxLayoutAlign="end">

        <!--  Action Button    -->
        <button fxFlex="50" class="action-button confirm-cart" mat-raised-button color="primary" (click)="onClicked()">
            {{buttonLabel}}
        </button>

        <ng-container *ngIf="!isBuyFast && isShowButton && !showBackToEventPackageDetailBtn">
            <a fxFlex="50" mat-stroked-button translate="shared.labels.continueShopping"
                [href]="routerService.getSeamHomePageUrl()">
            </a>
        </ng-container>

        <button fxFlex="50" class="action-button" mat-stroked-button color="primary"
            translate="shared.labels.eventPackageReturn" *ngIf="showBackToEventPackageDetailBtn"
            (click)="navigateToEventPackageDetailPage(shoppingCart.btxEventPackageId)">

        </button>


        <div>

        </div>
    </div>
</div>

<div class="ykbContainer" fxHide.lt-md>
    <img fxFlex="100" [src]="'https://www.biletix.com/static/images/design2025/ykb_275x145.png'" alt="Yapı Kredi World" />
</div>

<div class="campaign-banner">
    <a [href]="getCampaignUrl()" target="_blank"><img [src]="getCampaignImageUrl()" alt="Black Friday"
            (error)="handleMissingImage($event)"></a>
</div>